import React from "react";
import { toast } from "react-toastify";
import { TOAST_TYPES } from "../framework/constant/constant";

const toastTypes = {
  success: toast.success,
  error: toast.error,
  info: toast.info,
  warning: toast.warning
};

const ToastNotification = ({ type = TOAST_TYPES.ERROR, title = "INVALID", message = "", position = toast.POSITION.TOP_RIGHT, style = {}, autoClose = 3000, }) => {
  const showToast = toastTypes[type] || toast.info;

  showToast(
    <div>
      {title && <strong>{title}</strong>}
      {message && (<div style={{ fontSize: "13px", ...style }}>{message}</div>)}
    </div>,
    { position, autoClose }
  );
};

export default ToastNotification;